module.exports = __webpack_public_path__ + "media/icons/szkody-pojazdu-orange-7ff63687.png";